export default "__VITE_ASSET__C4rKCA00__"